import { cn } from "@/service/classname.ts";
import { createColourFromString } from "@/service/name";
import { ComponentPropsWithoutRef } from "react";

type Props = ComponentPropsWithoutRef<"div"> & {
  name: string;
  roundedSquare?: boolean;
  size?: "small" | "normal" | "large";
};

export const Avatar = ({
  name,
  roundedSquare = false,
  className,
  size,
  ...rest
}: Props) => {
  const names = name.split(" ");
  const first = names.at(0)?.at(0)?.toLocaleUpperCase();
  const last = names.at(-1)?.at(0)?.toLocaleUpperCase();

  let sizeCn = cn("size-10");

  if (size === "small") sizeCn = cn("size-7 text-xs");
  if (size === "large") sizeCn = cn("size-14 text-xl");

  return (
    <div
      {...rest}
      data-testid="avatar"
      className={cn(
        className,
        "grid shrink-0 place-content-center text-white select-none",
        roundedSquare ? "rounded-squircle" : "rounded-full",
        sizeCn
      )}
      style={{ backgroundColor: createColourFromString(name) }}
    >
      {first}
      {last}
    </div>
  );
};
